import { IFlyerState } from "../types/flyer-state/flyer-state.interface";
import { FlyerActions, FlyerActionType } from "./flyer.actions";
import { createFlyerState } from "../types/flyer-state/flyer-state.functions";
import { LOADING_STATES } from "../../../features/loading";
import { flyerTemplateCreatorReducer } from "../pages/flyer-template-creator/store/flyer-template-creator.reducer";
import { FlyerTemplateCreatorActionsType } from "../pages/flyer-template-creator/store/flyer-template-creator.actions";
import { flyerDetailReducer } from "../pages/flyer-detail/store/flyer-detail.reducer";
import { FlyerDetailActionType } from "../pages/flyer-detail/store/flyer-detail.actions";

export function flyerReducer(state = createFlyerState(), action: FlyerActionType): IFlyerState {
  switch (action.type) {
    case FlyerActions.Create:
    case FlyerActions.Delete:
    case FlyerActions.Fetch:
      return {
        ...state,
        loading: LOADING_STATES.loading,
      };

    case FlyerActions.CreateFailure:
    case FlyerActions.DeleteFailure:
      return {
        ...state,
        errors: action.payload,
        loading: LOADING_STATES.default,
      };

    case FlyerActions.DeleteSuccess:
      return {
        ...state,
        errors: null,
        loading: LOADING_STATES.default,
      };

    case FlyerActions.FetchFailure:
      return {
        ...state,
        errors: action.payload,
        loading: LOADING_STATES.failed,
        searchResults: null,
      };

    case FlyerActions.FetchSuccess:
      return {
        ...state,
        errors: null,
        filters: action.payload.filters,
        loading: LOADING_STATES.loaded,
        searchResults: action.payload.results,
      };

    case FlyerActions.SetModalOpenState:
      return {
        ...state,
        errors: null,
        isCreateModalOpen: action.payload,
      };

    case FlyerActions.ClearErrors:
      return {
        ...state,
        errors: null,
      };
    case FlyerActions.SetPermissions:
      return {
        ...state,
        permissions: action.payload,
      };
    case FlyerActions.SetGridView:
      return {
        ...state,
        isGridView: action.payload,
      };
    case FlyerActions.SetFilterOptions:
      return {
        ...state,
        filterOptions: { ...action.payload },
      };
    default:
      return {
        ...state,
        templateCreatorState: flyerTemplateCreatorReducer(
          state.templateCreatorState,
          action as FlyerTemplateCreatorActionsType
        ),
        flyerDetailState: flyerDetailReducer(
          state.flyerDetailState,
          action as FlyerDetailActionType
        ),
      };
  }
}
